import { FC, SVGProps } from 'react'

const UserIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="user-icon"
    {...svgProps}
  >
    <path
      d="M15.9267 16H0.145826C0.145826 16 -0.182282 14.1143 0.145826 12.7429C0.473933 11.3714 4.76666 10 8.03562 10C11.3046 10 15.7617 11.2 15.9267 12.9143C16.0917 14.6286 15.9267 16 15.9267 16Z"
      fill="currentColor"
    />
    <path
      d="M12 4C12 6.20914 10.2092 8 8.00004 8C5.7909 8 4.00004 6.20914 4.00004 4C4.00004 1.79086 5.7909 0 8.00004 0C10.2092 0 12 1.79086 12 4Z"
      fill="currentColor"
    />
  </svg>
)

export default UserIcon
